export default function AboutMission() {
  const features = [
    {
      icon: 'ri-refresh-line',
      title: 'Automate',
      description: 'Repetitive tasks, eliminated.',
    },
    {
      icon: 'ri-links-line',
      title: 'Integrate',
      description: 'Your tools, connected.',
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Simplify',
      description: 'Operations, streamlined.',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Scale',
      description: 'Growth, unlocked.',
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-4">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className="bg-card rounded-2xl p-6 border border-border hover:border-primary/30 hover:shadow-lg transition-all duration-300"
                >
                  <div className="w-10 h-10 flex items-center justify-center mb-3">
                    <i className={`${feature.icon} text-2xl text-primary`}></i>
                  </div>
                  <h4 className="font-display text-foreground font-semibold mb-1">
                    {feature.title}
                  </h4>
                  <p className="text-muted-foreground text-sm">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="text-primary text-sm font-semibold tracking-wider uppercase mb-4 block text-center">
              Our Mission
            </span>
            <h2 className="text-3xl md:text-4xl font-display text-foreground mb-6 leading-tight">
              Making automation accessible to every service business.
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Too many businesses are stuck doing things manually — not because they want to, but because automation felt too complex or too expensive.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              We design custom AI-powered workflows for lead intake, scheduling, follow-ups, CRM management, and client communications — tailored to fit your existing operations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}